import { useState } from 'react';
import logoUrl from '@/assets/logo.jpg';
import { auth } from '@/api/endpoints';
import { errorMessage } from '@/api/client';
import { setSession, type SessionUser } from '@/auth/session';
import { Button, ErrorBox, Form, Input } from '@/components/ui';
import { required } from '@/utils/format';

export function AdminLoginScreen({ onSuccess }: { onSuccess: (user: SessionUser) => void }) {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit() {
    const miss = required({ phone, password }, ['phone', 'password']);
    if (miss) {
      setError(miss);
      return;
    }
    setLoading(true);
    setError('');
    const res = await auth.login({ phone, password });
    setLoading(false);
    if (!res.success) {
      setError(errorMessage(res));
      return;
    }
    const token = typeof res.token === 'string' ? res.token : '';
    const user = (res.user && typeof res.user === 'object' ? res.user : null) as SessionUser | null;
    if (!token || !user) {
      setError('لم يُرجع الخادم بيانات الدخول.');
      return;
    }
    setSession(token, user);
    onSuccess(user);
  }

  return (
    <main className="auth-layout">
      <section className="auth-card">
        <div className="brand-row centered">
          <img src={logoUrl} className="brand-logo" alt="اشحنلي" />
          <div>
            <h1>إدارة اشحنلي</h1>
            <p>تسجيل الدخول</p>
          </div>
        </div>
        <Form className="form-grid" onSubmit={() => void submit()}>
          <Input
            label="الهاتف"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            autoComplete="username"
            required
          />
          <Input
            label="كلمة المرور"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          {error ? <ErrorBox message={error} /> : null}
          <Button type="submit" disabled={loading}>
            {loading ? 'جاري الدخول…' : 'دخول'}
          </Button>
        </Form>
      </section>
    </main>
  );
}
